module.exports = __webpack_public_path__ + "static/salena-padilla-flag-marking-afa0b6751fdc38a520209bc23796dcc9.jpg";